module.exports = __webpack_public_path__ + "img/him_logo.e3264126.png";